import {TableColumn} from '@fl/cmsch-fe-library';

import {getCenterCodeFormat, getFarmCodeFormat} from './get-code-format';
import {OrganizationTableType} from '../../types/organization-table-type';

/** Table columns for the organizations tab. */
export const columns: Array<TableColumn<OrganizationTableType>> = [
    {
        field: 'organizationCode',
        type: 'string',
        customFiltersOnly: true,
        filterTypes: ['containsString', 'null'],
    },
    {
        field: 'organizationName',
        type: 'string',
        filterTypes: ['containsStringOr', {type: 'multiSelectStringOrEquals', subtype: 'bulkString'}, 'null'],
    },
    {
        field: 'roleCode',
        type: 'string',
        filterTypes: ['containsStringOr', {type: 'multiSelectStringOrEquals', subtype: 'bulkString'}, 'null'],
    },
    {
        field: 'roleName',
        type: 'string',
        filterTypes: ['containsStringOr', {type: 'multiSelectStringOrEquals', subtype: 'bulkString'}, 'null'],
    },
    {
        field: 'approvedFrom',
        type: 'date',
        dateFormat: 'date',
    },
    {
        field: 'approvedTo',
        type: 'date',
        dateFormat: 'date',
        filterTypes: ['null'],
    },
    {
        field: 'organizationCenterCode',
        type: 'string',
        formatValue: getCenterCodeFormat,
        filterTypes: ['containsStringOr', {type: 'multiSelectStringOrEquals', subtype: 'bulkString'}, 'null'],
    },
    {
        field: 'farmCode',
        type: 'string',
        formatValue: getFarmCodeFormat,
        filterTypes: ['containsStringOr', {type: 'multiSelectStringOrEquals', subtype: 'bulkString'}, 'null'],
    },
];
